// extracted by mini-css-extract-plugin
module.exports = {"button":"string-button_button__1y-CN"};